const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'LOGOUT':
      return defaultState;
    case 'SET_CUSTOMERS':
      return {customers: action.customers};
    default:
      return state;
  }
};
